import { useTranslation } from 'react-i18next'
import { Waypoints } from 'lucide-react'

import { ObjectPicker } from '@/components/ObjectPicker'
import { Card, CardContent, CardHeader, CardIcon, CardTitle } from '@/components/ui/card'
import { type LineItem } from '@/services/lineItems/lineItemsApi'
import { searchLineItems } from '@/services/lineItems/lineItemSearch'

export interface DiagnosticLineItemPickerProps {
  value?: LineItem
  onChange: (lineItem: LineItem | undefined) => void
}

/** Picks the one line item a diagnostic run reports on, by name or id. */
export function DiagnosticLineItemPicker({ value, onChange }: DiagnosticLineItemPickerProps) {
  const { t } = useTranslation()
  return (
    <Card tone="insight">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <CardIcon icon={Waypoints} />
          {t('diagnostics.lineItem')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {/* One line item at most: picking another replaces it. */}
        <ObjectPicker<LineItem>
          queryKey="diagnostics-line-item-search"
          search={searchLineItems}
          selected={value ? [value] : []}
          onChange={(next) => onChange(next.at(-1))}
          addLabel={t('diagnostics.pickLineItem')}
          searchPlaceholder={t('diagnostics.searchLineItem')}
          emptyText={t('diagnostics.allLineItems')}
          renderMeta={(lineItem) => lineItem.id}
        />
      </CardContent>
    </Card>
  )
}
